import React from "react";
import CardTemplate from "./CardTemplate";
import styled from "styled-components";
import { EventData } from "hooks/ConsultantDashboard/useConsultantDashboardData";
import { convertYMDToMDYYYY } from "utils/DateConversion";

interface Props {
	eventSchedule: EventData[] | null;
}

const EventSchedule = ({ eventSchedule }: Props) => {
	return (
		<CardTemplate title={"Event Schedule"}>
			<Container>
				{eventSchedule === null ||
				eventSchedule === undefined ||
				eventSchedule.length === 0 ? (
					<StyledEvent>No events created</StyledEvent>
				) : (
					<>
						{eventSchedule.map((event: EventData, index) => {
							return (
								<StyledEvent key={index}>
									{convertYMDToMDYYYY(event.scheduleDate)} -{" "}
									{event.eventName}
								</StyledEvent>
							);
						})}
					</>
				)}
			</Container>
		</CardTemplate>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
`;

const StyledEvent = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
`;

export default EventSchedule;
